import React from 'react'
import {Grid, Typography, Button, Checkbox} from '@mui/material';
import colors from '../../../colors'
import SingleInvoice from './SingleInvoice'
import SingleExpandedInvoice from './SingleExpandedInvoice'
import * as config from '../../../config'
import NetworkService from '../../../general/NetworkService'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useSelector, useDispatch } from 'react-redux';
import {selectGlobalDataState} from '../../../../features/global/globalDataSlice'
import {sendGeneralRequest} from '../../../../features/generalRequest'
import { selectUtilityState, displayMainUtilityView } from '../../../../features/utilities/utilitySlice';
import {determineInvoiceListRequest} from '../utilities/DetermineInvoiceListRequest'
import { texts } from '../../../general/texts';
import { displaySingleInvoice, setSingleInvoice, displayOneMainUtilityView } from '../../../../features/oneMobile/oneSlice';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: theme.palette.background.paper,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
    scrollBar: {
      "&::-webkit-scrollbar": {
        width: "10px",
        height:"50%",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: '#FFFFFF',
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
        borderRadius: "10px",
        maxHeight:'50%'
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: 'linear-gradient(to bottom, #EF7A30, #F0A13D)',
      },
        maxHeight:'53vh',
        overflow:'auto',
        paddingLeft:'6%',
        marginTop:'1%',
        '@media (max-width: 899px )' : {height:'80%'}
    }
  }));

const InvoiceList = (props) => 
{
    const dispatch = useDispatch()
    const selectGlobalDataSliceState = useSelector(selectGlobalDataState)
    const utilitySliceState = useSelector(selectUtilityState)
    const classes = useStyles();
    const [invoices, setInvoices] = React.useState([])
  
    const handleInvoiceClick = (value) =>
    {
      if (props.utilityName === 'TELEKOM ALBANIA') {
        dispatch(setSingleInvoice(value))
        dispatch(displaySingleInvoice(true))
      }
      else {
        const invoiceListRequest = determineInvoiceListRequest(props.utilityName, selectGlobalDataSliceState.token, value, utilitySliceState.extraInvoiceListData )
        dispatch(invoiceListRequest)
      }
    }
    
    React.useEffect(()=>{ 
        setInvoices(props.invoices)
    },[props.invoices])

    return(
        <Grid container p={2.4}>
            <Grid container pt={3} pb={2}>
                <Grid container item md={1.5} xs={3} justifyContent={'left'} alignContent={'center'}  ><Button onClick={()=> {props.utilityName === 'TELEKOM ALBANIA' ? dispatch(displayOneMainUtilityView()) : dispatch(displayMainUtilityView())}} sx={{height:'4rem', borderRadius:'100%',":hover":{background:colors.white}}} ><ArrowBackIosNewIcon color='warning' /></Button></Grid>
                <Grid container item md={10} xs={8} justifyContent={'left'} alignContent={'center'} ><Typography sx={{fontWeight:'bold', color:colors.darkBlue, fontFamily:'GerberaBold'}} variant='h5'>{texts["title-obligations-list"]}</Typography></Grid>
            </Grid>
            <Grid item md={12} xs={12} className={classes.scrollBar} maxHeight= {'53vh'} overflow= {'auto'}>
                <List className={classes.root}>     
                    {invoices.length > 0 && invoices.map((invoice, index) => {
                        return <Grid item md={12} key={index} ><SingleInvoice utilityName={props.utilityName} utilityInfo={props.utilityInfo} contractData={invoice} onClick={() => {handleInvoiceClick(invoice)}}/></Grid>
                    })}    
                </List>                          
            </Grid>    
        </Grid>   
    )
}
export default InvoiceList
